<template>
  <div id="trails-app">
    <!-- Check if we have Umbraco page data -->
    <div v-if="umbracoPageData">
      <!-- Render based on page type -->
      <HomePage v-if="umbracoPageData.contentType === 'homePage'" :data="umbracoPageData" />
      <GenericPage v-else :data="umbracoPageData" />
    </div>
    
    <!-- Fallback for development mode without Umbraco -->
    <div v-else class="dev-environment">
      <Header />
      <Hero />
      <AboutSection />
      <GameElements />
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Hero from './components/Hero/Hero.vue'
import AboutSection from './components/AboutSection.vue'
import GameElements from './components/GameElements'
import Footer from './components/Footer.vue'
import HomePage from './components/Pages/HomePage.vue'
import GenericPage from './components/Pages/GenericPage.vue'

export default {
  name: 'App',
  components: {
    Header,
    Hero,
    AboutSection,
    GameElements,
    Footer,
    HomePage,
    GenericPage
  },
  data() {
    return {
      umbracoPageData: null
    }
  },
  mounted() {
    // Get Umbraco page data if available (set by Razor view)
    if (window.umbracoPageData) {
      this.umbracoPageData = window.umbracoPageData
    }
  }
}
</script>

<style scoped>
#trails-app {
  min-height: 100vh;
}

.dev-environment {
  /* Development styles */
}
</style>
